import { render, staticRenderFns } from "./LeaderboardWinner.vue?vue&type=template&id=d4777602&scoped=true&"
import script from "./LeaderboardWinner.vue?vue&type=script&lang=js&"
export * from "./LeaderboardWinner.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardWinner.vue?vue&type=style&index=0&id=d4777602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4777602",
  null
  
)

export default component.exports